<template>
  <div data-test-id="SimpleSpinner" aria-live="polite" aria-busy="true" class="simple-spinner" />
</template>

<style lang="postcss">
.simple-spinner {
  aspect-ratio: 1 / 1;
  width: 3rem;
  border: 5px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  animation: rotation 0.6s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
